import React, { Component } from 'react'
import PropTypes from 'prop-types'
import isEqual from 'lodash/isEqual'
import get from 'lodash/get'

import LogoContainer from './components/LogoContainer'
import Intro from './components/scenes/Intro'
import Splash from './components/scenes/Splash'
import VideoSlide from './components/scenes/VideoSlide'
import Showcase from './components/showcase/Showcase'
import RotateNotification from '../shared/components/RotateNotification'
import { initApi, api } from '../../api/integrationAPI'
import { runSequence, stopSequence } from 'utils/sequence'
import { appLoaded } from '../shared/analytics'
import { customCSSObjectToString } from 'utils/serializerCSS'
import { preloadImagesExtended, scrollFix } from '../../utils/templatesUtils'
import ButtonClose from './components/buttonClose/ButtonClose'

import * as scenes from './scenes'
import { imagesUrls } from './template/appImages'

import './InstantApp.scss'


export default class InstantApp extends Component {

  constructor (props) {
    // console.log('InstantApp constructor')
    super(props)
    window.logTiming('InstantApp constructor')
    this.checkIsBackward()
    const initialLocation = this.getInitialLocation(props)
    // console.log('initial location', initialLocation)
    this.state = {
      scene: initialLocation.scene,
      showcaseNum: initialLocation.showcaseNum,
      productShown: initialLocation.productShown,
      isCartOpened: false,
      shareButtonsVisible: 0,
      initialized: false,
      cart: null
    }
  }

  checkIsBackward = () => {
    const pathname = document.location.pathname
    const prmstr = window.location.search.substr(1)
    const isBackward = prmstr === '1'
    if (isBackward) history.pushState({}, 'redirectFromPage', pathname)
    this.isBackward = isBackward
  }


  getInitialLocation = (props) => {
    const { location, editMode } = props
    if (this.isBackward) {
      return {
        scene: scenes.SHOWCASE,
        showcaseNum: props.settings.showcases.length,
        productShown: null,
      }
    } else if (editMode) {
      return {
        scene: location.scene,
        showcaseNum: location.showcaseNum,
        productShown: get(location, 'productShown', null)
      }
    } else {
      return {
        scene: scenes.PRELOAD,
        showcaseNum: 0,
        productShown: null,
      }
    }
  }

  componentDidMount () {
    const { editMode, showcaseMode, appId, settings, dispatch } = this.props
    if (!editMode && !showcaseMode) {
      scrollFix()
    }

    let iOSinsta = /iPad|iPhone|iPod/ && /Instagram/.test(navigator.userAgent) && !window.MSStream

    if (iOSinsta) {
      // document.getElementsByTagName('html')[0].style.height = 'calc(100% - 64px)'
      // document.getElementsByTagName('html')[0].style.marginTop = '64px'
      document.getElementsByTagName('html')[0].style.height = '100%'
      document.getElementsByTagName('body')[0].style.position = 'absolute'
      document.getElementsByTagName('html')[0].addEventListener('touchmove', e => this.onTouchMove(e))
      document.getElementsByTagName('html')[0].addEventListener('touchstart', e => this.onTouchStart(e))
    }

    this.initIntegration(appId, settings.appSettings.integration, dispatch)

    if (this.prodMode()) appLoaded()

    if (!this.props.editMode) {
      const images = imagesUrls(settings)
      preloadImagesExtended(images, this.onImgagesPackLoaded)
      this.readyTimer = setTimeout(() => {
        // console.log('ready timeout done, is ready', this.ready)
        if (!this.ready) {
          this.ready = true
          this.startAnimations()
        }
      }, 3000)
    }
  }

  onImgagesPackLoaded = (packNum) => {
    // console.log('onImgagesPackLoaded', packNum, 'isReady', this.ready)
    if (packNum === 0 && !this.ready) {
      this.ready = true
      if (!this.props.editMode) this.startAnimations()
    }
  }

  onTouchStart (e) {
    console.log(e.target)
    const touch = e.touches[0]
    this.setState({
      prevPositionY: touch.pageY
    })
  }

  onTouchMove (e) {
    // console.log(e.target.className)
    if (!e.target.className.includes('js-scroll')) {
      e.preventDefault()
    } else if (e.target.className.includes('js-scroll-x')) {
      const touch = e.touches[0]
      if (touch.pageY - this.state.prevPositionY < 0) {
        if (touch.pageY - this.state.prevPositionY < -10) {
          e.preventDefault()
        }
      } else {
        if (touch.pageY - this.state.prevPositionY > 10) {
          e.preventDefault()
        }
      }
    }
  }

  startAnimations () {
    // console.log('Start Animations')
    const { settings } = this.props
    const toSplash = { fn: () => this.updateState({scene: scenes.SPLASH}), delay: 10 }
    const toIntro = { fn: () => this.updateState({scene: scenes.INTRO}), delay: 3000 }
    const toVideo = { fn: () => settings.door ? this.updateState({scene: scenes.VIDEO}) : this.updateState({scene: scenes.SHOWCASE}), delay: 4000 }
    let sequence = []
    switch (this.state.scene) {
      case scenes.PRELOAD :
        sequence = [ toSplash, toIntro, toVideo ]
        break
      case scenes.SPLASH :
        sequence = [ toIntro, toVideo ]
        break
      case scenes.INTRO :
        sequence = [ toVideo ]
        break
      default:
        break
    }
    if (sequence.length > 0) this.sequenceId = runSequence(sequence)
  }

  componentWillReceiveProps (nextProps) {
    const location = nextProps.location
    if (!location.productShown) location.productShown = null

    this.setState({ ...location, isCartOpened: false }) // Exit shopping cart if something's changed in editor
    const newIntegration = nextProps.settings.appSettings.integration
    const oldIntegration = this.props.settings.appSettings.integration

    if (!isEqual(newIntegration, oldIntegration)) {
      this.setInitialized(false, () => {
        const { appId, settings, dispatch } = nextProps
        this.initIntegration(appId, settings.appSettings.integration, dispatch)
      })
    }

    if (!this.props.showcaseMode && nextProps.showcaseMode) {
      this.startAnimations()
    }
  }

  componentWillUnmount () {
    stopSequence(this.sequenceId)
    this.onLoadedStylesheet = () => null
    this.setInitialized = () => null
    clearTimeout(this.readyTimer)
  }

  onChangeCart = (cart) => {
    // console.log('onChangeCart', cart)
    this.setState({ cart })
  }

  setInitialized = (value, callback = () => null) => {
    // console.log('setInitialized', value, 'api:', api)
    window.logTiming('setInitialized called')
    if (!this.state.initialized && value) {
      window.logTiming('setInitialized')
      this.setState({
        cart: api.getCart(),
        initialized: true
      })
      api.setOnChangeCart(this.onChangeCart)
    } else if (!value) {
      if (api) api.setOnChangeCart(null)
      this.setState({
        cart: null,
        initialized: false
      }, callback)
    }
  }

  initIntegration (appId, integration, dispatch) {
    // console.log('initApi')
    window.logTiming('initApi')
    const { settings, editMode, showcaseMode } = this.props
    if (!editMode || (editMode && showcaseMode)) {
      const productIds = []
      // console.log('settings', settings)
      for (const showcase of settings.showcases) {
        for (const p of showcase.products) {
          if (p.productId) productIds.push(p.productId)
        }
      }
      // console.log('productIds', productIds)
      initApi(appId, integration, this.setInitialized, dispatch, productIds)
    } else {
      initApi(appId, integration, this.setInitialized, dispatch)
    }
  }

  prodMode = () => !this.props.editMode && !this.props.showcaseMode

  updateState (patch) {
    console.log('IA update state', patch)
    const { scene, showcaseNum, productShown, shareButtonsVisible } = this.state
    if (patch.scene !== scene ||
        patch.showcaseNum !== showcaseNum ||
        patch.productShown !== productShown ||
        patch.shareButtonsVisible !== shareButtonsVisible
      ) {
      this.setState(patch, () => {
        const loc = {
          scene: this.state.scene,
          showcaseNum: this.state.showcaseNum,
          productShown: this.state.productShown,
          shareButtonsVisible: this.state.shareButtonsVisible
        }
        if (this.prodMode()) window.ga('send', 'screenview', {screenName: JSON.stringify(loc)})
        // console.log('call onChange', loc)
        this.props.onChange(loc)
      })
    }
  }

  switchCart = () => { // Display/hide shopping cart
    this.setState({ isCartOpened: !this.state.isCartOpened })
  }

  nextScene = () => {
    if (this.state.showcaseNum < this.props.settings.showcases.length) {
      this.updateState({ showcaseNum: this.state.showcaseNum + 1 })
    }
  }

  previousScene = () => {
    if (this.state.showcaseNum > 0) {
      this.updateState({ showcaseNum: this.state.showcaseNum - 1 })
    }
  }

  showProduct = (productKey) => {
    // console.log('showProduct')
    this.updateState({
      productShown: productKey,
      scene: scenes.PRODUCT_INFO
    })
  }

  setShareButtonsVisible = (v) => this.updateState({ shareButtonsVisible: v })

  closeProduct = () => { this.updateState({ productShown: null, scene: scenes.SHOWCASE }) }
  openSettings = () => { this.updateState({ scene: scenes.PRODUCT_DETAILS }) }
  closeSettings = () => { this.updateState({ scene: scenes.PRODUCT_INFO }) }

  handleSlideChange = (slide) => {
    console.log('handleSlideChange', slide)
    if (this.state.showcaseNum !== slide) {
      this.updateState({ showcaseNum: slide })
    }
  }

  onLoadedStylesheet = () => {
    this.forceUpdate()
  }

  onLinkMounted = (linkRef) => {
    if (linkRef) {
      linkRef.addEventListener('load', this.onLoadedStylesheet)
    }
  }

  renderButtonClose () {
    const { productShown, scene } = this.state
    const visible = !productShown && scene !== scenes.PRELOAD && scene !== scenes.SPLASH && window.shopName
    return <ButtonClose visible={visible} onClick={window.removeRootElt} />
  }

  render () {
    const { settings, editMode, showcaseMode } = this.props
    const { scene, showcaseNum } = this.state
    // console.log('InstantApp customStyles', settings.customStyles)
    return (
      <div className='ou_root'>
        <link
          key={settings.customStylesRawDownloadUrl}
          rel={'stylesheet'}
          ref={this.onLinkMounted}
          href={settings.customStylesRawDownloadUrl}
        />
        <link
          key={settings.customStylesDownloadUrl}
          rel={'stylesheet'}
          ref={this.onLinkMounted}
          href={settings.customStylesDownloadUrl}
        />
        <style id='customStyles'>{customCSSObjectToString(settings.customStyles)}</style>
        {!editMode && !showcaseMode && <RotateNotification />}
        {/* Top-left logo */}
        {scene !== scenes.SPLASH && scene !== scenes.PRELOAD &&
          <LogoContainer
            settings={settings}
            scene={scene}
            showcaseNum={showcaseNum}
          />
        }
        {/* Splash scene */}
        <Splash {...settings.splash} image={settings.intro.image} isVisible={scene === scenes.SPLASH} />
        {/* Intro scene with 3 text lines */}
        <Intro {...settings.intro} isVisible={scene === scenes.INTRO} />
        {/* Video scene */}
        {settings.door && <VideoSlide {...settings.door} closeVideo={this.closeProduct} isVisible={scene === scenes.VIDEO} />}
        {/* Swiper scene */}
        <Showcase
          settings={settings}
          cart={this.state.cart}
          showcaseNum={this.state.showcaseNum}
          productShown={this.state.productShown}
          scene={scene}
          isCartOpened={this.state.isCartOpened}
          showProduct={this.showProduct}
          handleSlideChange={this.handleSlideChange}
          previousScene={this.previousScene}
          nextScene={this.nextScene}
          switchCart={this.switchCart}
          closeProduct={this.closeProduct}
          openSettings={this.openSettings}
          closeSettings={this.closeSettings}
          isVisible={scene === scenes.SHOWCASE || scene === scenes.PRODUCT_INFO || scene === scenes.PRODUCT_DETAILS}
          editMode={editMode}
          showcaseMode={showcaseMode}
          setShareButtonsVisible={this.setShareButtonsVisible}
          prodMode={this.prodMode()}
        />
        {this.renderButtonClose()}
      </div>
    )
  }

  static defaultProps = {
    location: {
      scene: scenes.SPLASH,
      showcaseNum: 0,
      productShown: null
    },
    onChange: () => null,
    editMode: false,
    showcaseMode: false
  }

  static propTypes = {
    appId: PropTypes.string,
    settings: PropTypes.shape({
      appSettings: PropTypes.object,
      customStylesDownloadUrl: PropTypes.string,
      splash: PropTypes.object,
      intro: PropTypes.object,
      door: PropTypes.object,
      lastScene: PropTypes.object,
      productsDict: PropTypes.object,
      showcases: PropTypes.arrayOf(
        PropTypes.shape({
          image: PropTypes.string,
          products: PropTypes.array
        })
      )
    }).isRequired,
    onChange: PropTypes.func,
    editMode: PropTypes.bool, // Is IA runs in editor
    showcaseMode: PropTypes.bool, // Is IA displayed in editor's dashboard
    location: PropTypes.object, // eslint-disable-line react/no-unused-prop-types,
    dispatch: PropTypes.func
  }
}



// WEBPACK FOOTER //
// ./src/templates/outSide/InstantApp.js